import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Button, Card, Flex, Typography } from 'antd';

const { Paragraph } = Typography;

import AiIcon from '../../../../../components/AiIcon';

import { useHomeMessageId } from '../../../hooks/useHomeMessageId';
import { useHomeAuthModal } from '../HomeAuthModalContext';

const PrimaryCard = () => {
  const { openRegister } = useHomeAuthModal();
  const homeMessageId = useHomeMessageId();

  return (
    <Card className="home-page__primary-card" variant="borderless">
      <div className="home-page__primary-card-content">
        <Flex className="home-page__primary-card-heading" align="center">
          <AiIcon name="brand-primary-title" />
          <span>
            <FormattedMessage id={homeMessageId('brand')} />
          </span>
        </Flex>
        <strong>
          <FormattedMessage id={homeMessageId('stat.value')} />
        </strong>
        <Paragraph>
          <FormattedMessage id={homeMessageId('stat.text')} />
        </Paragraph>
        <Button className="outline" type="primary" onClick={openRegister}>
          <FormattedMessage id={homeMessageId('button.startFree')} />
          <AiIcon name="btn-primary-circle-arrow" />
        </Button>
      </div>
      <div className="home-page__network" />
    </Card>
  );
};

export default PrimaryCard;
